import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const initialState = {
  status: "idle",
  data: null,
  totalElements: 0,
  totalPages: 0,
  error: "",
}

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findAllTransaction.pending, (state, action) => {
      state.status = "loading"
    })
    builder.addCase(findAllTransaction.fulfilled, (state, action) => {
      state.status = "succeeded"
      state.data = action.payload.page
      state.totalElements = action.payload.totalElements
      state.totalPages = action.payload.totalPages
    })
    builder.addCase(findAllTransaction.rejected, (state, action) => {
      state.status = "failed"
      state.error = action.payload
    })
  },
})

export const findAllTransaction = createAsyncThunk(
  "/transaction/find-all",
  async (
    {
      start = 0,
      limit = 75,
      user = "%",
      providerId = "%",
      paymentMethod = "%",
      cpeType = "%",
      cpeSeries = "%",
      cpeNumber = "%",
      tracking = 2,
      state = 1,
      sinceDate = "",
      untilDate = "",
      jwt,
    },
    thunkAPI
  ) => {
    try {
      const endpoint = `/transaction/console?start=${start}&limit=${limit}&user=%25${user}%25&provider-id=%25${providerId}%25&payment-method=%25${paymentMethod}%25&cpe-type=%25${cpeType}%25&cpe-series=%25${cpeSeries}%25&cpe-number=%25${cpeNumber}%25&tracking=${tracking}&state=${state}&since-date=${sinceDate}&until-date=${untilDate}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: jwt },
      })
      return thunkAPI.fulfillWithValue(data)
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const getTransaction = (state) => state.transaction
export default transactionSlice.reducer
